import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import { Title } from '../Shared';

export function FormWrapper(props) {
  const { title } = props;
  return (
    <div className={'pl-4 pr-4'}>
      <Title text={title} />
      <Container className="mt-4" style={{ flex: 1, backgroundColor: '#fff' }}>
        <Row>
          <Col sm={12} md={{ size: 4, offset: 4 }}>
            <h4
              className="orange-title text-center"
              style={{ paddingBottom: 15 }}
            >
              {title}
            </h4>
            {props.children}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

FormWrapper.propTypes = {
  title: PropTypes.string.isRequired,
};
